export default "__VITE_ASSET__e570219c__"